import { Injectable } from '@angular/core';
import { Store, select } from '@ngrx/store';
import * as UserStateActions from './user-state.actions';
import * as UserStateSelectors from './user-state.selectors';

@Injectable({
    providedIn: 'root',
})
export class UserStateFacade {
    isAuthenticated$ = this.store$.pipe(select(UserStateSelectors.isAuthenticatedSelector));
    loggedInUser$ = this.store$.pipe(select(UserStateSelectors.loggedInUserSelector));
    userRoleData$ = this.store$.pipe(select(UserStateSelectors.userRoleDataSelector));
    userStatus$ = this.store$.pipe(select(UserStateSelectors.userStatusSelector));

    private currentLoggedInUser: Record<string, unknown> | null = null;
    private currentUserRoleData: Record<string, unknown> | null = null;
    private currentUserStatus: 'Active' | 'Inactive' = 'Active';

    constructor(private readonly store$: Store) { }

    setIsAuthenticated(isAuthenticated: boolean): void {
        this.store$.dispatch(UserStateActions.setIsAuthenticated({ isAuthenticated }));
    }

    setLoggedInUser(loggedInUser: Record<string, unknown> | null): void {
        this.currentLoggedInUser = loggedInUser;
        this.store$.dispatch(UserStateActions.setLoggedInUser({ loggedInUser }));
    }

    getCurrentLoggedInUser(): Record<string, unknown> | null {
        return this.currentLoggedInUser;
    }

    setUserRoleData(userRoleData: Record<string, unknown> | null): void {
        this.currentUserRoleData = userRoleData;
        this.store$.dispatch(UserStateActions.setUserRoleData({ userRoleData }));
    }

    setUserStatus(userStatus: 'Active' | 'Inactive'): void {
        this.currentUserStatus = userStatus;
        this.store$.dispatch(UserStateActions.setUserStatus({ userStatus }));
    }

    getCurrentUserRoleData(): Record<string, unknown> | null {
        return this.currentUserRoleData;
    }

    getCurrentUserStatus(): 'Active' | 'Inactive' {
        return this.currentUserStatus;
    }

    resetUserState(): void {
        this.currentLoggedInUser = null;
        this.currentUserRoleData = null;
        this.currentUserStatus = 'Active';
        this.store$.dispatch(UserStateActions.resetUserState());
    }
}
